// extracted by mini-css-extract-plugin
export var container = "_km-0";
export var dotAnimation = "_km-2";
export var dotsLoading = "_km-1";